export default function IncompleteAssessmentDirective() {
  return {
    template: require('./incomplete-assessment.html'),
    scope: {
      assessment: '=',
      isNavantaUser: '=',
    },
    controller: 'PRAIncompleteAssessmentController',
    controllerAs: 'incompleteAssessmentVM',
    bindToController: true,
    replace: true,
  };
}
